import HARDCODE from '../../business-const/HardCode/HardCode'

import TAMMAX from '../TamMax/TamMax'

import {
    GridItem12,
} from '../../business-components/Grid/Grid'

import formPrimeiraReuniaoPadraoList from './formPrimeiraReuniaoPadraoList'

import simNaoList from "./simNaoList"



const formPrimeiraReuniaoInvestimento80List = () => {

    const formList = [...formPrimeiraReuniaoPadraoList]
    
    formList.push(
       {
            id: 1010,
            descricao: 'Como está o seu fluxo hoje?',
            default: false,
            grupoPergunta: 'Contexto Financeiro',
            type: 'Radio',
            list: [
                {id: 'S', descricao: 'Sobra', ordem: 10},
                {id: 'E', descricao: 'Equilibra', ordem: 20},
                {id: 'A', descricao: 'Aperta', ordem: 30},
            ],
            GridItemRadioList: GridItem12,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 1010,
        },
        {
            id: 1020,
            descricao: 'Se a sua renda parasse amanhã, a família estaria protegida?',
            default: false,
            grupoPergunta: 'Proteção de Renda',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 1020,
        },
        {
            id: 1030,
            descricao: 'Qual o tipo e valor do seguro?',
            default: false,
            grupoPergunta: 'Proteção de Renda',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 1020,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 1030,
        },
        {
            id: 1040,
            descricao: 'Pretende comprar imóvel, veículo ou expandir nos próximos 1–2 anos?',
            default: false,
            grupoPergunta: 'Aquisição de Bens',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 1040,
        },
        {
            id: 1050,
            descricao: 'Qual bem e valor desejado?',
            default: false,
            grupoPergunta: 'Aquisição de Bens',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 1040,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 1050,
        },
    )

    return formList
}
 
export default formPrimeiraReuniaoInvestimento80List